module.exports = __webpack_public_path__ + "img/Xgrow-11-es.482411ab.png";